/* src/app/component/promotion-analytics/promotion-analytics.component.scss */
.with-sidebar {
  margin-left: 250px;
  padding: 32px;
  background-color: #FCFCFD;
  overflow-y: auto;
}
.no-sidebar {
  padding: 32px;
  background-color: #FCFCFD;
  overflow-y: auto;
}
.analytics-heading {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 24px;
  padding-left: 12px;
}
.analytics-card-grid {
  display: flex;
  gap: 20px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}
.analytics-card {
  flex: 1;
  padding: 8px 16px;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
}
.analytics-card h4 {
  color: #d47500;
  margin-bottom: 8px;
}
.analytics-card .count {
  font-size: 24px;
  font-weight: bold;
}
.analytics-card .subtext {
  font-size: 14px;
  color: #555;
}
.chart-section {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}
.chart-card {
  flex: 1;
  min-width: 400px;
  padding: 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.card-header {
  font-size: 18px;
  color: #2f2f2f;
  font-weight: 600;
  margin-bottom: 0px;
}
:host ::ng-deep input {
  height: 36px !important;
}
:host ::ng-deep .p-datepicker {
  transform-origin: top center !important;
  top: unset !important;
  bottom: auto !important;
  left: -100px !important;
  margin-top: 40px !important;
}
@media screen and (max-width: 1200px) {
  :host ::ng-deep .p-datepicker {
    transform-origin: top center !important;
    top: unset !important;
    bottom: auto !important;
    left: -160px !important;
    margin-top: 40px !important;
  }
}
/*# sourceMappingURL=promotion-analytics.component-NE2DSPWT.css.map */
